import { GetBaseCompanyInfoViaCompanyId } from '@/http/Company/company';
import queryKeys from '@/util/hooks/queries/queryKeys';
import { useQuery } from '@tanstack/react-query';

/**
 * Resolves a company's display name by id (PBI #6096 — the Pending Approvals Inbox only
 * gets `supplierCompanyId` back from Integration-Gateway). Reuses the existing
 * `GetBaseCompanyInfoViaCompanyId` endpoint (the same one `useBaseCompanyInfo` calls for
 * the logged-in user's own company) rather than the heavier `useCompanyProfileView`, which
 * fetches full profile data (addresses/contacts/BEE/COIDA/bank/documents) we don't need
 * just for a name. No existing hook wrapped this endpoint for an arbitrary companyId, so
 * this is a small dedicated wrapper — per-row fetch is acceptable since inbox lists are short.
 */
export const useSupplierCompanyName = (companyId: number) =>
  useQuery({
    queryKey: [queryKeys.companyBaseInfoById, companyId],
    queryFn: () => GetBaseCompanyInfoViaCompanyId(companyId, false),
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
    select: (data) => data.companyRegisteredName
  });
